var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 8H16a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V16a8 8 0 00-8-8zM24 47h-5V27h5v20zm.029-23.991c-.647.66-1.491.991-2.529.991-1.026 0-1.865-.341-2.519-1.023S18 21.458 18 20.468c0-1.02.327-1.852.981-2.498.654-.647 1.493-.97 2.519-.97 1.038 0 1.882.323 2.529.969.647.646.971 1.479.971 2.499 0 1.034-.324 1.881-.971 2.541zM47 47h-5V35.887C42 32.788 40.214 31 38 31c-1.067 0-2.274.648-2.965 1.469S34 34.331 34 35.594V47h-5V27h5v3.164h.078c1.472-2.435 3.613-3.644 6.426-3.652C44.5 26.5 47 29.5 47 34.754V47z"
  })));
}

export default SvgLinkedIn;